<template>
  <div class="flex items-center w-full justify-between select-none">
    <div
      v-for="step in steps"
      :key="step.id"
      class="flex items-center text-primary cursor-pointer transition-width duration-500 md:transition-none"
      @click="navigate(step.id)"
      :class="{
        'md:text-secondary': step.id === tab,
        'md:text-primary': tab > step.id,
      }"
    >
      <div
        class="w-8 h-8 md:mr-3 mr-2 flex justify-center items-center rounded-full text-sm"
        :class="{
          'bg-secondary text-white': step.id === tab,
          'border border-current text': step.id !== tab && tab < step.id,
          'bg-primary ': tab > step.id,
        }"
      >
        <div v-if="tab <= step.id" v-html="step.id" class="font-bold" />
        <NuxtImg loading="lazy" v-else src="/icons/check.png" alt="check" class="w-5" />
      </div>

      <div
        v-html="step.title"
        class="text-sm md:mr-3 font-semibold"
        :class="tab == step.id ? 'flex text-secondary' : 'hidden md:flex'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["navigate"]);

interface stepperProps {
  tab?: number;
}

const props = withDefaults(defineProps<stepperProps>(), {
  tab: 1,
});

const { t } = useI18n();

const steps = [
  { id: 1, title: t("orderProcessing.stepper.account") },
  { id: 2, title: t("orderProcessing.stepper.patientDetails") },
  { id: 3, title: t("orderProcessing.stepper.payment") },
  { id: 4, title: t("orderProcessing.stepper.confirmation") },
];

const navigate = (id: number) => {
  if (props.tab == 4 || id >= props.tab) return;

  emit("navigate", id);
};
</script>
